import React, { useState, useEffect } from 'react';
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import './ProjectGallery.css';

const ProjectGallery = ({ 
    images, 
    title, 
    initialIndex = 0,
    maxVisibleThumbnails = 7,
    showTitle = true 
}) => {
    const [currentImageIndex, setCurrentImageIndex] = useState(initialIndex);
    const [showThumbnails, setShowThumbnails] = useState(true);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const selectImage = (index) => {
        setCurrentImageIndex(index);
    };

  // Определяем, какие миниатюры показывать (по умолчанию максимум 7 штук)
    const getVisibleThumbnails = () => {
        const visibleCount = maxVisibleThumbnails;
        const totalImages = images.length;
        
        if (totalImages <= visibleCount) {
            return images.map((img, idx) => ({ img, idx }));
        }
        
        let startIdx = Math.max(0, currentImageIndex - Math.floor(visibleCount / 2));
        if (startIdx + visibleCount > totalImages) {
            startIdx = totalImages - visibleCount;
        }
        
        return images
            .slice(startIdx, startIdx + visibleCount)
            .map((img, idx) => ({ img, idx: idx + startIdx }));
    };

    useEffect(() => {
        // Адаптация интерфейса на мобильных устройствах
        const handleResize = () => {
            setShowThumbnails(window.innerWidth > 576);
        };

        handleResize(); // Инициализация
        window.addEventListener('resize', handleResize);
    
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="gallery-section">
            {showTitle && title && <h2 className="gallery-title">{title}</h2>}
      
            <div className="gallery-container">
                <div className="main-image-container">
                    <button className="gallery-nav-button prev-button" onClick={prevImage} aria-label="Предыдущее изображение">
                        <BsChevronLeft />
                    </button>
                
                    <div className="main-image">
                        <img 
                            src={images[currentImageIndex]} 
                            alt={`Изображение ${currentImageIndex + 1}`} 
                            className="img-fluid"
                            draggable="false"
                            onDragStart={(e) => e.preventDefault()}
                        />
                    </div>
                
                    <button className="gallery-nav-button next-button" onClick={nextImage} aria-label="Следующее изображение">
                        <BsChevronRight />
                    </button>
                </div>
                
                {showThumbnails && images.length > 1 && (
                    <div className="thumbnails-container">
                        <button className="thumbnail-nav-button prev-button" onClick={prevImage} aria-label="Предыдущие миниатюры">
                            <BsChevronLeft />
                        </button>
                        
                        <div className="thumbnails-row">
                            {getVisibleThumbnails().map(({ img, idx }) => (
                                <div 
                                    key={idx}
                                    className={`thumbnail ${currentImageIndex === idx ? 'active' : ''}`}
                                    onClick={() => selectImage(idx)}
                                    draggable="false"
                                    onDragStart={(e) => e.preventDefault()}
                                >
                                    <img src={img} alt={`Миниатюра ${idx + 1}`} />
                                </div>
                            ))}
                        </div>
                        
                        <button className="thumbnail-nav-button next-button" onClick={nextImage} aria-label="Следующие миниатюры">
                            <BsChevronRight />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectGallery;